import { Eye, HelpCircle, Trash, X } from "lucide-react";
import {
  deleteBorrowerChattel,
  getBorrowerChattels,
} from "../../../sdk/borrower/borrower";
import { useQuery, useMutation } from "react-query";
import { useError } from "../../../context/ErrorProvider";
import { useState } from "react";

const LoanChattels = ({
  closeLoanChattels,
  borrower,
  handleAddChattel,
  refetchApplication,
}) => {
  const { showError } = useError();
  const { data: chattels, refetch: refetchChattels } = useQuery({
    queryKey: ["chattels", borrower?.id],
    queryFn: () => getBorrowerChattels(borrower?.id),
    initialData: [],
    enabled: !!borrower?.id,
  });

  const { mutate: deleteMyChattel } = useMutation({
    mutationKey: ["delete a chattel"],
    mutationFn: (id) => deleteBorrowerChattel(id),
    onSuccess: () => {
      refetchApplication();
      refetchChattels();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const [expandedChattel, setExpandedChattel] = useState(null);

  const handleDeleteChattel = (chattel) => {
    deleteMyChattel(chattel?.id);
  };

  const toggleExpand = (chattel) => {
    setExpandedChattel((prev) => (prev?.id === chattel?.id ? null : chattel));
  };

  return (
    <div
      onClick={() => closeLoanChattels()}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[600px] rounded-[10px] p-[20px] relative bg-white overflow-y-auto"
      >
        {/* Close Button */}
        <div
          onClick={closeLoanChattels}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>

        {/* Header */}
        <div className="flex items-end justify-between">
          <div>
            <p className="text-[#000000] font-normal text-[14px]">
              Edit Loan Application
            </p>
            <p className="text-[#000000] font-semibold text-[20px]">
              Borrower’s Chattels
            </p>
            <p className="text-[#5C5C5C] text-[14px] font-normal">
              Record borrower’s chattels to be tied to this loan
            </p>
          </div>
          <button
            onClick={handleAddChattel}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            Add a Chattel
          </button>
        </div>

        {/* Table Header */}
        <div className="h-[40px] w-full bg-[#F3F3F3] mt-[20px] px-[10px] flex items-center">
          <div className="w-[15%] text-[#222222] font-normal text-[14px]">
            ID
          </div>
          <div className="w-[30%] text-[#222222] font-normal text-[14px]">
            NAME
          </div>
          <div className="w-[27%] text-[#222222] font-normal text-[14px]">
            CHATTEL LOCATION
          </div>
          <div className="w-[24%] truncate text-[#222222] font-normal text-[14px]">
            VIEW / DELETE
          </div>
        </div>

        {/* Table Body */}
        {chattels?.length === 0 ? (
          <div className="h-[350px] flex flex-col items-center justify-center gap-[10px]">
            <HelpCircle />
            <p>No chattel information available</p>
          </div>
        ) : (
          chattels?.map((item) => (
            <div key={item?.id}>
              <div className="h-[40px] w-full bg-white px-[10px] flex items-center">
                <div className="w-[15%] text-[#222222] text-[14px]">
                  {item?.public_id}
                </div>
                <div className="w-[30%] text-[#00A676] text-[14px]">
                  {item?.name}
                </div>
                <div className="w-[27%] text-[#222222] text-[14px]">
                  {item?.location}
                </div>
                <div className="w-[24%] flex gap-3 items-center">
                  <Eye
                    onClick={() => toggleExpand(item)}
                    className="w-4 h-4 text-[#222222] cursor-pointer"
                  />
                  <Trash
                    onClick={() => handleDeleteChattel(item)}
                    className="w-4 h-4 text-[#222222] cursor-pointer"
                  />
                </div>
              </div>

              {/* Expanded Details */}
              {expandedChattel?.id === item?.id && (
                <div className="p-4 bg-gray-50 text-sm text-gray-700">
                  <p className="font-bold">Chattel details</p>
                  <p>
                    <strong>Name:</strong> {item?.name || "N/A"}
                  </p>
                  <p>
                    <strong>Description:</strong> {item?.description || "N/A"}
                  </p>
                  <p>
                    <strong>Value:</strong> {item?.value || "N/A"}
                  </p>
                  <p>
                    <strong>Location:</strong> {item?.location || "N/A"}
                  </p>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LoanChattels;
